import { checkoutOptimizationStepArraySchema } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getCheckoutTreeFlowStepsForSplit = {
  name: "getCheckoutTreeFlowStepsForSplit" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.object({
    steps: checkoutOptimizationStepArraySchema,
    splitStatus: z.union([
      z.literal("scheduled"),
      z.literal("active"),
      z.literal("concluded"),
    ]),
  }),
};
export type GetCheckoutTreeFlowStepsForSplitOutput = z.infer<
  typeof getCheckoutTreeFlowStepsForSplit.output
>;
